export default function (rating) {
  if (!rating) return null
  rating = rating.replace(/[0-9]/g, '')
  return `https://vblimages.blob.core.windows.net/images/Badges/vbl_badges_blue_${rating.toLowerCase()}.png`
}
